import { Component, OnInit } from '@angular/core';
import { ViewState } from 'src/common';

@Component({
  selector: 'request-create',
  templateUrl: 'request-create.component.html'
})

export class RequestCreateComponent implements OnInit {

  viewState = ViewState;

  constructor() { }

  ngOnInit() { }
}
